"use client";

import { useLoyaltyBrandContext } from "@saas/loyalty/feature/@context/loyalty-brand/loyalty-brand.context";

export interface IRegisterPageHeadingProps {
  testid: string;
}

export const RegisterPageHeading = ({ testid }: IRegisterPageHeadingProps) => {
  const { brandName } = useLoyaltyBrandContext();

  return (
    <div>
      <h1
        className={"body-b1 text-he mb-1 font-semibold"}
        data-testid={`${testid}__text__title`}
      >
        Buat akun {brandName} Loyalti Program
      </h1>
      <p
        className={"text-le body-b3"}
        data-testid={`${testid}__text__description`}
      >
        Dengan satu langkah dapatkan banyak manfaat.
      </p>
    </div>
  );
};
